/* /tilbud – Kvitebergs tilbud til Skarpenord som en offentlig side (uten innlogging). Norsk. */
import { SKARPENORD_NO } from "../data/tilbod/skarpenord";
import { ProductProposal } from "../components/proposal/ProductProposal";
import "../proposal.css";

export default function TilbudProposalPage() {
  return <ProductProposal d={SKARPENORD_NO} />;
}
